import React from "react"
import { useParams } from "react-router-dom"
import PhotographyListing from "../../../components/Listing/PhotographyListing"

/**
 * Admin City Photography — GET /api/v1/admin/photography?city_id=
 * Paginated grid (no status tabs).
 */
const AdminCityPhotography = () => {
  const { cityId } = useParams()

  return (
    <PhotographyListing
      documentTitle="Photography | AMOK . EARTH Admin"
      cityId={cityId}
      showExport
      pageSize={10}
    />
  )
}

export default AdminCityPhotography
